export const safeGuidanceHeading = 'Get help now if you need it';

export const restartFromNhsAppGuidancePoints = [
  'Start again from the NHS App if you want to try this journey again.',
  'Call 111 if you need urgent medical help or advice.',
  'Call 999 if this is an emergency.',
] as const;

export interface FailureHelpLink {
  label: string;
  href: string;
}

export type FailureMessageSegment = string | FailureHelpLink;

export const serviceBusyTitle = 'Sorry, there is a problem with the service';
export const serviceBusyMessageParagraphs: readonly (readonly FailureMessageSegment[])[] = [
  [
    'Try again or use ',
    { label: '111 online', href: 'https://111.nhs.uk/' },
    ' or ',
    { label: 'call 111', href: 'tel:111' },
    '.',
  ],
  [
    'In case of emergency, ',
    { label: 'call 999', href: 'tel:999' },
    ' immediately.',
  ],
];
export const serviceBusyRetryLabel = 'Try again';

export const reconnectFromNhsAppGuidancePoints = [
  'Reconnect to the internet and try again from the NHS App if you want to continue this journey.',
  'Call 111 if you need urgent medical help or advice.',
  'Call 999 if this is an emergency.',
] as const;